<ng-select 
    [items]="pessoas" 
    [(ngModel)]="pessoaId" 
    [ngModelOptions]="{standalone: true}"
    (keyup)="filtrar($event)"
    bindLabel="nome" 
    bindValue="id" 
    notFoundText="Não há dados para esse filtro"
    loadingText="Buscando"
    placeholder="Digite o nome ou CPF/CNPJ" 
    (click)="changePessoa($event)"
    [loading]="loadPessoas"
    dropdownPosition="bottom"
    [multiple]="selecionaMultiplos"
    (add)="adicionarPessoaSelecionada($event)"
    (remove)="removerPessoaSelecionada($event)"
    (clear)="limparPessoa()">
    <ng-template ng-header-tmp *ngIf="selecionaMultiplos">
        <label class="m-0 d-flex align-items-center cursor-pointer-padrao" (click)="$event.stopPropagation()">
            <input
                type="checkbox"
                class="mr-2"
                [checked]="selecionarTodosMarcado && todasPessoasSelecionadas"
                (change)="alternarSelecaoTodas($event)">
            Selecionar todos
        </label>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
        <div class="line"><b>{{item.nome}}</b></div>
        <div class="line mb-1"><b>CPF/CNPJ</b>: {{item.cpfCnpj}}</div>                
    </ng-template>
</ng-select>
